import React, { useState } from "react";
import Navbar from "../layout/Navbar";
import ImageSlider from "../components/ImageSlider";
import FrameImage from "../assets/Frame 18419.png";
import image1 from "../assets/images1.jpg";
import image2 from "../assets/image2.jpg";
import image3 from "../assets/image3.jpg";
import traumaLogo from "../assets/NABH-logo.jpg";
import KioskImage from "../assets/4cf506861536a59696c5d61c02f1de8e.jpg";
import Footer from "../layout/Footer";
import { ChevronRight, Calendar, FileText, CreditCard, HelpCircle, UserPlus, Activity } from "lucide-react";
import { Link } from "react-router-dom";
import HBOT from "../assets/HBOT.jpeg"
import Physiotherapy from "../assets/physiotherapy&rehabilitation.jpeg"
import Oral from "../assets/oral_maxillofacial_surgery.jpeg"

const testimonialsData = [image1, image2, image3];

// Department icons with their colors
const departments = [
  { name: "Trauma Surgery", icon: "🩺", color: "bg-red-100 text-red-500" },
  { name: "Orthopedics", icon: "🦿", color: "bg-blue-100 text-blue-500" },
  { name: "Plastic Surgery", icon: "✂️", color: "bg-amber-100 text-amber-500" },
  { name: "Neurosurgery", icon: "🧠", color: "bg-purple-100 text-purple-500" },
  { name: "Oral Maxillofacial Surgery", image: Oral, color: "bg-pink-100 text-pink-500" },
  { name: "HBOT", image: HBOT, color: "bg-cyan-100" },
  { name: "Physiotherapy & Rehabilitation", image: Physiotherapy, color: "bg-green-100" },
];

// Stats for counter section
const stats = [
  { value: "354", label: "Beds" },
  { value: "12K+", label: "Admissions Yearly" },
  { value: "8.5K+", label: "Surgeries Yearly" },
  { value: "170K+", label: "OPD Patients Yearly" },
];

const Home = () => {
  const [showAll, setShowAll] = useState(false);

  return (
    <div className="bg-gray-50">
      <Navbar />
      <ImageSlider />

      {/* Quick Access Services */}
      <div className="py-10 px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
        <div className="text-center mb-8">
          <h2 className="text-3xl font-bold text-gray-900">Our Services</h2>
          <p className="mt-2 text-lg text-gray-600">Fast access to our most used hospital services</p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-4">
          {departments.map((dept, index) => (
            <div key={index} className="flex flex-col items-center p-4 bg-white rounded-xl shadow-sm hover:shadow-md transition-all cursor-pointer">
              {dept.image ? (
                <div className={`w-14 h-14 rounded-full ${dept.color} overflow-hidden mb-3 flex-shrink-0`}>
                  <img src={dept.image} alt={dept.name} className="w-full h-full object-cover" />
                </div>
              ) : (
                <div className={`w-14 h-14 rounded-full ${dept.color} flex items-center justify-center text-2xl mb-3`}>
                  {dept.icon}
                </div>
              )}
              <h3 className="font-medium text-gray-800 text-center">{dept.name}</h3>
            </div>
          ))}
        </div>
      </div>

      {/* Stats Counter Section */}
      <div className="bg-gradient-to-r from-teal-600 to-cyan-700 py-12">
        <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
          <div className="text-center mb-8">
            <h2 className="text-3xl font-bold text-white">By The Numbers</h2>
            <p className="mt-2 text-lg text-teal-100">Our impact in healthcare delivery</p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {stats.map((stat, index) => (
              <div key={index} className="text-center bg-white/10 backdrop-blur-sm p-6 rounded-xl">
                <p className="text-4xl font-bold text-white">{stat.value}</p>
                <p className="text-teal-100 mt-1">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <img src={FrameImage} alt="FrameImage" className="w-full" />

      {/* Patient Portal & Kiosk Section - Updated with icons */}
      <div className="py-16 bg-white">
        <div className="flex flex-col items-center gap-10 px-4 mx-auto max-w-7xl sm:px-6 lg:px-8 lg:flex-row">
          {/* Left Image */}
          <div className="w-full lg:w-1/2">
            <div className="relative">
              <div className="absolute -top-4 -left-4 w-24 h-24 bg-teal-100 rounded-full z-0"></div>
              <div className="absolute -bottom-4 -right-4 w-16 h-16 bg-blue-100 rounded-full z-0"></div>
              <img
                src={KioskImage}
                alt="Patient Portal"
                className="object-cover w-full shadow-lg rounded-xl relative z-10"
              />
            </div>
          </div>

          {/* Right Content */}
          <div className="w-full lg:w-1/2">
            <div className="inline-block px-4 py-1 mb-4 text-sm font-medium bg-teal-100 text-teal-800 rounded-full">
              For Patients
            </div>
            <h2 className="mb-2 text-3xl font-bold text-gray-900">
              Explore our{" "}
              <span className="text-teal-600">
                Patient Portal & Kiosk
              </span>
            </h2>
            <p className="mb-8 text-lg text-gray-600">
              An integrated portal exclusively crafted for patients' convenience
            </p>

            <ul className="space-y-6">
              {[
                [UserPlus, "Self Register", "Self Register to bypass long queues at hospital."],
                [Calendar, "Manage Appointments", "Book new appointment, view and modify existing appointments."],
                [Activity, "Self Service Kiosk", "Self Registration, Online Payment and Billing, Laboratory report print."],
                [FileText, "View Medical Records", "Securely and conveniently view and download your medical records with ease."],
                [CreditCard, "View Bills & Payments", "Securely and conveniently view and track your bills and payments with ease."],
                [HelpCircle, "CEVAT Desk", "One-stop solution for your inquiries, feedback, and essential information."],
              ].map(([Icon, title, desc], index) => (
                <li key={index} className="flex items-start">
                  <div className="mr-4 p-2 bg-teal-100 rounded-lg text-teal-700">
                    <Icon className="w-5 h-5" />
                  </div>
                  <div>
                    <p className="font-medium text-gray-900">{title}</p>
                    <p className="text-gray-600">{desc}</p>
                  </div>
                </li>
              ))}
            </ul>

            <button className="mt-8 px-6 py-3 bg-teal-600 text-white rounded-lg flex items-center hover:bg-teal-700 transition-colors">
              Access Patient Portal
              <ChevronRight className="ml-2 w-5 h-5" />
            </button>
          </div>
        </div>
      </div>

      {/* Testimonials Section - Updated */}
      <div className="py-16 bg-gray-50">
        <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
          <div className="text-center mb-8">
            <div className="inline-block px-4 py-1 mb-4 text-sm font-medium bg-blue-100 text-blue-800 rounded-full">
              Patient Stories
            </div>
            <h2 className="text-3xl font-bold text-gray-900">
              Testimonials
            </h2>
            <p className="mt-2 text-lg text-gray-600">What our patients say about us</p>
          </div>

          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3">
            {(showAll
              ? testimonialsData
              : testimonialsData.slice(0, 3)
            ).map((image, index) => (
              <div key={index} className="bg-white rounded-xl shadow-md overflow-hidden transition-transform hover:scale-105">
                <img
                  src={image}
                  alt={`testimonial-${index}`}
                  className="object-cover w-full h-48"
                />
                <div className="p-4">
                  <p className="text-gray-600 italic">"The care I received was exceptional. The staff was attentive and professional."</p>
                  <div className="mt-4 flex items-center">
                    <div className="w-8 h-8 bg-teal-100 rounded-full flex items-center justify-center text-teal-600 font-bold">
                      {String.fromCharCode(65 + index)}
                    </div>
                    <div className="ml-3">
                      {/* <p className="font-medium text-gray-900">Patient {index + 1}</p> */}
                      <p className="text-sm text-gray-500">Trauma Care</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-8 text-center">
            <button
              className="px-6 py-2 text-teal-600 border border-teal-600 rounded-lg hover:bg-teal-50 transition-colors"
              onClick={() => setShowAll(!showAll)}
            >
              {showAll ? "Show Less" : "View All Testimonials"}
            </button>
          </div>
        </div>
      </div>

      {/* Trauma Centre IMS BHU Section - Updated */}
      <div className="py-16 bg-white">
        <div className="flex flex-col items-center gap-10 px-4 mx-auto max-w-7xl sm:px-6 lg:px-8 lg:flex-row-reverse">
          {/* Right Side Image */}
          <div className="w-full lg:w-1/2">
            <div className="relative">
              <div className="absolute -top-4 -right-4 w-24 h-24 bg-blue-100 rounded-full z-0"></div>
              <img
                src={require("../assets/building-image.jpg")}
                alt="Trauma Centre IMS BHU"
                className="object-cover w-full shadow-lg rounded-xl relative z-10"
              />
            </div>
          </div>

          {/* Left Content */}
          <div className="w-full lg:w-1/2">
            <div className="inline-block px-4 py-1 mb-4 text-sm font-medium bg-blue-100 text-blue-800 rounded-full">
              About Us
            </div>
            <h2 className="mb-4 text-3xl font-bold text-cyan-700">
              Trauma Centre IMS BHU, Varanasi
            </h2>
            <p className="mb-6 text-gray-700 leading-relaxed">
              The Trauma Centre, Banaras Hindu University, located
              at Varanasi, is India's Level 1 referral Trauma
              Centre with 354 bedded facility 24×7 available for
              trauma patients used widely in the Eastern and
              Central regions of India including Uttar Pradesh,
              Bihar, Madhya Pradesh, Uttarakhand etc. On an
              average, every year, approximately 1.7 lakh patients
              visit Trauma Centre to avail the indoor, outdoor and
              advanced technology based investigations which ease
              in their diagnosis and facilitate in their
              treatment.
            </p>

            <ul className="space-y-4 text-gray-700 mb-8">
              <li className="flex items-start bg-blue-50 p-3 rounded-lg">
                <span className="mt-1 mr-3 text-blue-500">
                  📍
                </span>
                <span>Conveniently situated in Varanasi, just 20 minutes from Railway station and 60 min from the airport.</span>
              </li>
              <li className="flex items-start bg-blue-50 p-3 rounded-lg">
                <span className="mt-1 mr-3 text-blue-500">
                  🏥
                </span>
                <span>A 354+ bed Trauma Center super specialty hospital in 24 acre campus</span>
              </li>
              <li className="flex items-start bg-blue-50 p-3 rounded-lg">
                <span className="mt-1 mr-3 text-blue-500">
                  🩺
                </span>
                <span>All major medical specialties, diagnostics, rehabilitation, and physical therapy under one roof.</span>
              </li>
            </ul>

            {/* Buttons */}
            <div className="flex flex-wrap gap-4">
              <Link to="https://maps.app.goo.gl/tyfE2eEW2x2oiUgN7">
                <button className="px-6 py-3 text-white bg-cyan-600 rounded-lg hover:bg-cyan-700 transition-colors flex items-center">
                  Get Direction 🚗
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Accreditation Section */}
      <div className="py-12 bg-gray-50">
        <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8 text-center">
          <div className="inline-block px-4 py-1 mb-4 text-sm font-medium bg-indigo-100 text-indigo-800 rounded-full">
            Recognition
          </div>
          <h3 className="text-2xl font-bold text-gray-900 mb-2">
            Accreditations
          </h3>
          <p className="text-gray-600 mb-8 max-w-2xl mx-auto">
            Elevating Healthcare Standards at BHU Trauma Center through internationally recognized certifications
          </p>
          <div className="flex flex-wrap items-center justify-center gap-8">
            <div className="bg-white p-6 rounded-xl shadow-sm">
              <img
                src={traumaLogo}
                alt="NABL Accreditation"
                className="object-contain h-20"
              />
            </div>
            {/* Add more accreditation logos as needed */}
          </div>
        </div>
      </div>

      {/* Call to Action */}
      <div className="bg-gradient-to-r from-cyan-700 to-teal-600 py-16">
        <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-white mb-4">Need Immediate Assistance?</h2>
          <p className="text-cyan-100 mb-8 max-w-2xl mx-auto">
            Our medical professionals are available 24/7 to help you with your healthcare needs
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <button className="px-8 py-3 bg-white text-teal-700 font-medium rounded-lg hover:bg-teal-50 transition-colors">
              Emergency: +91 0542–2366073
            </button>
            <button className="px-8 py-3 bg-white text-teal-700 font-medium rounded-lg hover:bg-teal-50 transition-colors">
              Email : osdtraumabhu@gmail.com
            </button>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Home;